var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"from-boti":false,"title":("התזרים של " + _vm.monthName + " מוכן "),"text":'אפשר לעבור על התזרים ולערוך אותו עם העפרון ✏️',"notification-buttons":[
                  {
                    size:'normal',
                    title:'להסבר על התזרים',
                    subTitle: 'איך בנינו אותו?',
                    variant: 'primary',
                    action: _vm.openTour,
                  },
                  {
                    size:'normal',
                    title:'לתזרים',
                    variant: 'secondary',
                    action: _vm.skipTour,
                  } ]}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c73aa0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/notification/notification-types/CashflowTourNotification.vue
// module id = null
// module chunks = 